import { makeStyles } from '@material-ui/styles'
import { useMemo } from 'react'
import Badge from 'core/elements/badge'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

const IpBadge = ({ fixedIps }) => {
  if (!fixedIps || fixedIps?.length <= 1) return null
  const classes = useStyles()

  return (
    <Badge
      variant="unknown"
      text={`+${fixedIps?.length - 1} more IP(s)`}
      tooltipBody={
        <div className={classes.tooltipContainer}>
          <div>Private IP(s):</div>
          <ul className={classes.tooltipList}>
            {fixedIps?.map((fixedIp) => (
              <li key={fixedIp?.ip_address} className={classes.tooltipItem}>
                {fixedIp?.ip_address}
              </li>
            ))}
          </ul>
        </div>
      }
      bold={false}
      className={classes.badge}
    />
  )
}

const PortOption = ({ port }) => {
  const classes = useStyles()

  return (
    <Text variant="body2" className={classes.optionContent}>
      {port?.fixed_ips?.[0]?.ip_address}
      <IpBadge fixedIps={port?.fixed_ips} /> (MAC: {port?.mac_address})
    </Text>
  )
}

const VmPortsPicklist = ({
  disabled = false,
  name = 'vmPort',
  label = 'VM Port',
  vmPorts,
  loading,
  ...rest
}) => {
  const options = useMemo(() => {
    return vmPorts?.map((port) => ({
      // Map all IPs to ensure the search works correctly
      label: `${port?.fixed_ips?.map((ip) => ip?.ip_address)?.join(', ')} (MAC: ${
        port?.mac_address
      })`,
      value: port?.id,
      content: <PortOption port={port} />,
    }))
  }, [vmPorts])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      enableSearch
      items={options}
    />
  )
}

export default VmPortsPicklist

const useStyles = makeStyles<Theme>((theme) => ({
  optionContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  badge: {
    '& > span': {
      color: theme.palette.grey[700],
    },
  },
  tooltipContainer: { padding: theme.spacing(1) },
  tooltipList: { margin: 0, paddingLeft: theme.spacing(2) },
  tooltipItem: { padding: theme.spacing(0.5) },
}))
